import { render, staticRenderFns } from "./pvAllocation.vue?vue&type=template&id=29a99896&"
import script from "./pvAllocation.vue?vue&type=script&lang=js&"
export * from "./pvAllocation.vue?vue&type=script&lang=js&"
import style0 from "./pvAllocation.vue?vue&type=style&index=0&id=29a99896&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports